<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'施設情報' | translate}}</h1>

  <div *ngIf="!!adminUser" class="basic-button" fxLayoutGap="10px">
    <button mat-raised-button color="primary" [disabled]="facilityRegiLimit <= dataSource.data.length"
      (click)="openAddDialog()">
      <mat-icon>add</mat-icon>
      <span>{{'追加' | translate}}</span>
    </button>

    <button mat-raised-button color="warn" (click)="deleteData()" [disabled]="!selection.selected.length">
      <mat-icon>delete</mat-icon>
      <span>{{'削除' | translate}}</span>
    </button>
  </div>
</div>

<div class="filter-field" fxLayout="row" fxLayoutGap="20px">
  <mat-form-field fxFlex="25%">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
  </mat-form-field>
  <mat-form-field fxFlex="15%">
    <mat-select placeholder="{{'属性' | translate}}" id="facilityAttributeId" (selectionChange)="applyFilterAttr($event)">
      <mat-option [value]= ""></mat-option>
      <mat-option *ngFor="let facilityAttribute of facilityAttributes" [value]="facilityAttribute.attribute_id">
        {{ facilityAttribute.attribute_names | multiName:projectLanguages:projectBaseLang }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="center center">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef> No. </th>
      <td mat-cell *matCellDef="let facility; let i = index"> {{ (i + 1) + (paginator.pageSize * paginator.pageIndex) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef> {{'編集' | translate}} </th>
      <td mat-cell *matCellDef="let facility">
        <button mat-button color="primary" (click)="openEditDialog(facility)">
          <mat-icon>create</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef> {{'削除' | translate}} </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox [disabled]="!adminUser" color="warn" (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
          [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="facility_id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> ID </th>
      <td mat-cell *matCellDef="let facility"> {{ facility.facility_id }} </td>
    </ng-container>

    <ng-container matColumnDef="attribute">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'属性' | translate}} </th>
      <td mat-cell *matCellDef="let facility">
        <span
          *ngFor="let attribute of (facility.facility_attribute_id | docsByCond:attrCollectionName:'attribute_id' | async)">
          {{ attribute.attribute_names | multiName:projectLanguages:projectBaseLang }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'名称' | translate}} </th>
      <td mat-cell *matCellDef="let facility"> {{ facility.facility_names | multiName:projectLanguages:projectBaseLang }}
      </td>
    </ng-container>

    <ng-container matColumnDef="file">
      <th mat-header-cell *matHeaderCellDef> {{'画像' | translate}} </th>
      <td mat-cell *matCellDef="let facility">
        <img *ngIf="!!facility.facility_files[0]"
          [src]="(facility.facility_files[0].file_id | doc:uploadedFilesCollectionName | async)?.download_url"
          height="40px" width="auto">
      </td>
    </ng-container>

    <ng-container matColumnDef="floor">
      <th mat-header-cell *matHeaderCellDef> {{'フロア・表示グループ数' | translate}} </th>
      <td mat-cell *matCellDef="let facility"> {{ !!facility.floor_ids ? facility.floor_ids.length:0 }}
        {{'　' | translate}}</td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'更新日時' | translate}} </th>
      <td mat-cell *matCellDef="let facility"> {{ facility.updated.toDate() | date: 'yyyy/MM/dd HH:mm:ss' }} </td>
    </ng-container>

    <ng-container matColumnDef="reflect">
      <th mat-header-cell *matHeaderCellDef> {{'操作' | translate}} </th>
      <td mat-cell *matCellDef="let facility">
        <button mat-raised-button color="primary" (click)="reflectData(facility)">{{'本番反映' |
          translate}}</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>